import { PageTitle } from "@components/common/page-title";
import { UlmButton } from "@components/ulm/ulm-button";
import { UlmContainer } from "@components/ulm/ulm-container";
import { UlmTextField } from "@components/ulm/ulm-text-field";
import { useCallback, useState } from "react";

interface Props {
  setSSOId: (ssoId: string) => void;
}

/** Form to fill in the custom SSO ID */
export function SSOLoginForm({ setSSOId }: Props): JSX.Element {
  const [isError, setIsError] = useState<boolean>(false);
  const [value, setValue] = useState<string>("");
  const sanitizedValue = value.trim();
  const isValidValue = sanitizedValue.length > 0;

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    setIsError(false);
    setValue(event.target.value);
  }, []);

  const onClick = useCallback(() => {
    if (!isValidValue) {
      return setIsError(true);
    }

    setSSOId(sanitizedValue);
  }, [isValidValue, sanitizedValue, setSSOId]);

  return (
    <UlmContainer>
      <PageTitle>Company SSO ID</PageTitle>
      {/* TODO: https://faro01.atlassian.net/browse/ST-3547 It is disabled for now because some workflows don't work */}
      {/* <Box
        sx={{
          marginTop: "10px",
          fontSize: "14px",
          color: "text.secondary",
          display: "flex",
          alignItems: "center",
        }}
      >
        Don't remember your SSO ID?
        <Link
          component="button"
          underline="none"
          onClick={navigateToLogin}
          sx={{
            marginLeft: "5px",
            color: "primary.main",
          }}
        >
          Log in with email
        </Link>
      </Box> */}
      <UlmTextField
        value={value}
        type="text"
        isValidValue={isValidValue}
        isError={isError}
        errorText="At least one character is required"
        placeholder="Enter your company SSO ID"
        onChange={onChange}
        sx={{
          marginTop: "40px",
        }}
      />
      <UlmButton
        onClick={onClick}
        sx={{
          marginTop: "20px",
        }}
      >
        Continue
      </UlmButton>
    </UlmContainer>
  );
}
